import { createFileRoute } from '@tanstack/react-router';
import { InscriptionGate } from '@/features/subscription/shared/InscriptionGate';
import InscriptionProfessionalFieldPage from '@/features/subscription/inscription-professional-field-page/InscriptionProfessionalFieldPage';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

export const Route = createFileRoute('/vagas/$jobId_/inscricao/areas-de-atuacao')({
  component: () => (
    <InscriptionGate>
      <InscriptionProfessionalFieldPage />
    </InscriptionGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
